<div
  [ngClass]="{
    'buffer': 1,
    'open': tileHistoryActive
  }"
></div>
